import FlipCard from 'components/flip-card/FlipCard';
import GradientTitle from 'components/gradient-title/GradientTitle';
import Tags from 'components/tags/Tags';
import { UserBioBack } from 'components/user-bio/UserBioBack';
import { UserBioFront } from 'components/user-bio/UserBioFront';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultTheme, withTheme } from 'styled-components';
import { Speaker, Tag, UserBio } from 'types';
import { ButtonContent, ButtonLabel } from '../intro/styled';
import { CommitteeContainer, ContentContainer } from '../сommmittee/styled';
import { BlockTitleContainer, MoreBtn, MoreBtnContainer } from './styled';
import { PaginationInput, PaginationOutput } from 'kl-b2c-ui-kit';

const BASE_FILTERS = { page: 0, size: 8, tagIds: [], pristine: true };

type Config = PaginationInput & { tagIds: string[]; pristine?: boolean };

interface SpeakersProps {
    theme: DefaultTheme;
    tags: Tag[];
    speakers: PaginationOutput<Speaker> | null;
    setConfig: (props: Config) => void;
    setIsDirty: (isDirty: boolean) => void;
    config: Config;
    setOpenedIds: (id: string) => void;
}

const Speakers: FC<SpeakersProps> = ({ theme, tags, speakers, setConfig, setIsDirty, config, setOpenedIds }) => {
    const { t } = useTranslation('pages/home');
    const [activeSpeaker, setActiveSpeaker] = useState<string>();

    return (
        <CommitteeContainer id="speakers">
            <BlockTitleContainer>
                <GradientTitle
                    variant="h1"
                    label={t('speakers-title')}
                    startColor="#BBFF33"
                    finishColor="#53F592"
                    startLabelColor={theme.palette.black}
                    finishLabelColor={theme.palette.white}
                />
            </BlockTitleContainer>
            <Tags
                onChange={(chosen) => {
                    setConfig({ ...BASE_FILTERS, tagIds: chosen, pristine: true });
                    setIsDirty(true);
                }}
                tags={tags.map(({ id, name }) => ({ key: id, label: name }))}
                singleChoose
            />
            <ContentContainer>
                {speakers?.items?.map(
                    ({
                        id,
                        image,
                        firstName,
                        lastName,
                        position,
                        description,
                        twitterNickName,
                        nameOfReport,
                        defaultEvent,
                    }) => {
                        const bio: UserBio = {
                            name: `${firstName} ${lastName}`,
                            description: description || '',
                            image: image?.fileLink || '',
                            position,
                            twitter: twitterNickName,
                            nameOfReport,
                            event: defaultEvent,
                        };

                        return (
                            <FlipCard
                                id={`p${id}`}
                                key={id}
                                onClick={() => {
                                    if (!twitterNickName && !description) {
                                        return;
                                    }

                                    if (activeSpeaker === id) {
                                        setActiveSpeaker(undefined);
                                    } else {
                                        setActiveSpeaker(id);
                                    }
                                }}
                                preventFlip={!!twitterNickName || !!description}
                                isActive={id === activeSpeaker}
                                front={<UserBioFront {...bio} setOpenedIds={setOpenedIds} />}
                                back={<UserBioBack {...bio} />}
                            />
                        );
                    }
                )}
            </ContentContainer>
            {!!speakers?.count && !!speakers?.items?.length && speakers?.count > speakers?.items?.length && (
                <MoreBtnContainer>
                    {/*@ts-ignore*/}
                    <MoreBtn
                        type={'transparent'}
                        size={'large'}
                        onClick={() => {
                            setConfig({
                                page: config.page === 0 ? 2 : config.page + 1,
                                size: 4,
                                tagIds: config.tagIds,
                                pristine: false,
                            });
                        }}
                    >
                        <ButtonContent>
                            <ButtonLabel>{t('show-more-speakers')}</ButtonLabel>
                        </ButtonContent>
                    </MoreBtn>
                </MoreBtnContainer>
            )}
        </CommitteeContainer>
    );
};

export default withTheme(Speakers);
